define('commons/operator-selector',['jquery', 'commons/flat-tree-popup-group', 'utils/group'], function($, FlatTreePopupGroup, Group) {
    return function() {
        var operatorHiddenInput = $('input#operator-hidden');
    
        if (operatorHiddenInput.data('multiOpView') && typeof operatorHiddenInput.data('operatorPerm') != 'undefined') {
            var data = {};
            data[operatorHiddenInput.data('includeSvno') ? 'businessOperator' : 'networkOperator'] = true;
            if (operatorHiddenInput.data('excludeSatellite')) {
                data['excludeSatellite'] = true;
            }
            if (operatorHiddenInput.data('excludeNip')) {
                data['excludeType'] = Group.TYPE_NIP;
            }
            var onGroupSelected = function() {
                var data = $(this).data('itemInfo');
                operatorHiddenInput.val(data.id);
                operatorHiddenInput.trigger("change");
                $("#operatorName").val(data.text);
                groupSelector.dialogSelector.dialog('close');
                var fn = operatorHiddenInput.data('onGroupSelected');
                if (fn && typeof fn == 'function') {
                    fn.call(operatorHiddenInput, data.id);
                }
            };
            var groupSelector = new FlatTreePopupGroup('#select-operator', {
                width: '720px'
            }, {
                nbPanels: 1,
                data: data,
                perm: operatorHiddenInput.data('operatorPerm'),
                createItem: function(item) {
                    item.isLeaf = true;
                    item.isPathClickable = false;
                    return {
                        id: item.id,
                        text: item.text,
                        link: true,
                        events: {
                            click: onGroupSelected
                        }
                    };
                }
            });
            
        }
    };
});
